module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/metronome1Count-f6d66834e3bdc14d907a9cd1d19aa091.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/metronome1Count.mp3
// module id = 61
// module chunks = 0